export default __webpack_public_path__ + "f48cf1a460b730a950fe383eb578e75b.svg";